import {Flex, Radio, Typography} from "antd";
import {capitalize} from "lodash";
import {useTranslation} from "react-i18next";
import {useGetAssetBiodiversityDataSourcesQuery} from "../../../../redux/api/asset";
import {ALL_BIODIVERSITY_SOURCE} from "../../../assets/AssetsTable/filters/BiodiversitySourceFilter";
import {AssetsFiltersFE} from "../../../../types/internal/tables/assetsTable";
import {StaticAssetsFilters} from "../../../../types/internal/tables/assetsTable";

interface BiodiversitySourceFilterCreationAreasProps {
  filters: AssetsFiltersFE,
  addFilters: (addFilters: AssetsFiltersFE) => void,
  removeFilters: (removeFilters: ((StaticAssetsFilters | 'hazards') | string)[] | ((StaticAssetsFilters | 'hazards') | string)) => void,
}
export default function BiodiversitySourceFilterCreationAreas({
  filters,
  addFilters,
  removeFilters,
}: BiodiversitySourceFilterCreationAreasProps) {
  const value = filters.biodiversity_source?.length ? filters.biodiversity_source[0].value : ALL_BIODIVERSITY_SOURCE;
  const {t} = useTranslation();
  const {data} = useGetAssetBiodiversityDataSourcesQuery()
  const BIODIVERSITY_SOURCE_OPTIONS = (data ?? []).map(source => ({label: source.label, value: source.value}))

  return <Flex vertical gap={'0.5rem'}>
    <Typography.Text strong>
      {capitalize(t('assets.biodiversitySources'))}
    </Typography.Text>
    <Radio.Group
      options={BIODIVERSITY_SOURCE_OPTIONS}
      value={value}
      onChange={v => {
        const value = v.target.value
        if (value === ALL_BIODIVERSITY_SOURCE) {
          removeFilters('biodiversity_source');
        } else {
          const option = BIODIVERSITY_SOURCE_OPTIONS.find(el => el.value === value)
          if (option) {
            addFilters({biodiversity_source: [option]});
          }
        }
      }}
    />
  </Flex>
}
